import React, {PureComponent} from 'react';
import {NavLink} from "react-router-dom";

import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";
import {Redirect} from "react-router";
import {Modal} from "react-responsive-modal";

class ScreenChoice extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            infoModalOpen: false,
            infoModalTitle: null,
            infoModalBody: null,
        };
    }

    handleSwitchModal = (e) => {
        this.setState({
            infoModalOpen: !this.state.infoModalOpen,
        });
    };

    renderInfoModal = (e) => {
        let type = e.target.value;
        switch (type) {
            case "main": {
                this.setState({
                    infoModalOpen: true,
                    infoModalTitle: this.props.t("mainDashApp"),
                    infoModalBody: (
                        <div className={"App_text"} style={{fontSize: 18, padding: 10, textAlign: "center", fontWeight: "bold"}}>
                            <p>{this.props.t("mainDashApp_p1")}</p>
                            <p>{this.props.t("mainDashApp_p2")}</p>
                        </div>
                    )
                });

                break;
            }
            case "flag": {
                this.setState({
                    infoModalOpen: true,
                    infoModalTitle: this.props.t("flagMonitoringApp"),
                    infoModalBody: (
                        <div className={"App_text"} style={{fontSize: 18, padding: 10, textAlign: "center", fontWeight: "bold"}}>
                            <p>{this.props.t("flagMonitoringApp_p1")}</p>
                            <p>{this.props.t("flagMonitoringApp_p2")}</p>
                        </div>
                    )
                });
                break;
            }
            case "diag": {
                this.setState({
                    infoModalOpen: true,
                    infoModalTitle: this.props.t("deviceDiagnosticApp"),
                    infoModalBody: (
                        <div className={"App_text"} style={{fontSize: 18, padding: 10, textAlign: "center", fontWeight: "bold"}}>
                            <p>{this.props.t("deviceDiagnosticApp_p1")}</p>
                            <p>{this.props.t("deviceDiagnosticApp_p2")}</p>
                        </div>
                    )
                });
                break;
            }
            default: {
                break;
            }
        }
    };

    render() {
        return (!this.props.cookies.get("authToken") || !this.props.location.state) ? (
            <Redirect to={{pathname: "external-redirect/"}}/>
        ) : (
            <>
                <div className={"container col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2"} style={{marginTop: "10vh"}}>
                    <div className={"row w3-animate-fading"}>
                        <div className={"App_modernContainer col-xs-12 row-flex"}>
                            <div className={"container"}>
                                <br/>
                                <div className={"row row-flex"}>
                                    <div className={"col-xs-12"} style={{backgroundImage: "linear-gradient(to right, #F7F7F7 0, #eb1f247d 100%)", margin: "0 8px 5px 8px", borderRadius: 5}}>
                                        <span className={"text-center App_title"} style={{fontStyle: "italic", fontSize: 25}}>{this.props.t("chooseMainScreen")}</span>
                                    </div>
                                </div>
                                <br/>
                                <div className={"row row-flex"}>
                                    <div className={"col-sm-4"}>
                                        <div className={"panel panel-default"}>
                                            <div className={"panel-heading"} style={{textAlign: "center"}}>
                                                <span className={"App_title"}>{this.props.t("mainDashApp")}</span>
                                            </div>
                                            <div className={"panel-body"} style={{padding: 0}}>
                                                <div className={"col-xs-12 App_text"} style={{padding: 20, textAlign: "center"}}>
                                                    <i className="fas fa-tv" style={{fontSize: 100}}/>
                                                </div>
                                            </div>
                                            <div className={"panel-footer text-center"}>
                                                <NavLink
                                                    to={{
                                                        pathname: "/dashboard",
                                                        state: {
                                                            isGuest: false,
                                                            sessionID: this.props.location.state.sessionID,
                                                            eventID: this.props.location.state.eventID,
                                                            userID: this.props.location.state.userID,
                                                            privileges: this.props.location.state.privileges,
                                                        }
                                                    }}
                                                    className={"btn btn-primary button App_header"}
                                                >{this.props.t("open")}
                                                </NavLink>
                                                <button className={"btn button btn-primary "} style={{marginLeft: 10, backgroundColor: "#006fff"}} value={"main"} onClick={this.renderInfoModal}>
                                                    <i className={"fas fa-info"} style={{fontSize: 20, pointerEvents: "none"}}/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"col-sm-4"}>
                                        <div className={"panel panel-default"}>
                                            <div className={"panel-heading"} style={{textAlign: "center"}}>
                                                <span className={"App_title"}>{this.props.t("flagMonitoringApp")}</span>
                                            </div>
                                            <div className={"panel-body"} style={{padding: 0}}>
                                                <div className={"col-xs-12 App_text"} style={{padding: 20, textAlign: "center"}}>
                                                    <i className="fas fa-flag-checkered" style={{fontSize: 100}}/>
                                                </div>
                                            </div>
                                            <div className={"panel-footer text-center"}>
                                                <NavLink
                                                    to={{
                                                        pathname: "/flagMonitor/" + this.props.location.state.eventID + "/" + this.props.location.state.sessionID + "/" + this.props.location.state.userID,
                                                    }}
                                                    className={"btn btn-primary button App_header"}
                                                >{this.props.t("open")}
                                                </NavLink>
                                                <button className={"btn button btn-primary "} style={{marginLeft: 10, backgroundColor: "#006fff"}} value={"flag"} onClick={this.renderInfoModal}>
                                                    <i className={"fas fa-info"} style={{fontSize: 20, pointerEvents: "none"}}/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"col-sm-4"}>
                                        <div className={"panel panel-default"}>
                                            <div className={"panel-heading"} style={{textAlign: "center"}}>
                                                <span className={"App_title"}>{this.props.t("deviceDiagnosticApp")}</span>
                                            </div>
                                            <div className={"panel-body"} style={{padding: 0}}>
                                                <div className={"col-xs-12 App_text"} style={{padding: 20, textAlign: "center"}}>
                                                    <i className={"fas fa-tools"} style={{fontSize: 100}}/>
                                                </div>
                                            </div>
                                            <div className={"panel-footer text-center"}>
                                                <NavLink
                                                    to={{
                                                        pathname: "/diagnostic/" + this.props.location.state.eventID + "/" + this.props.location.state.sessionID + "/" + this.props.location.state.userID,
                                                    }}
                                                    className={"btn btn-primary button App_header"}
                                                >{this.props.t("open")}
                                                </NavLink>
                                                <button className={"btn button btn-primary "} style={{marginLeft: 10, backgroundColor: "#006fff"}} value={"diag"} onClick={this.renderInfoModal}>
                                                    <i className={"fas fa-info"} style={{fontSize: 20, pointerEvents: "none"}}/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal open={this.state.infoModalOpen}
                       onClose={this.handleSwitchModal}
                       center={false}
                       classNames={{modal: "small-modal"}}
                       showCloseIcon={false}
                >
                    <div className={"modal-header"}>
                        <div className={"modal-title"}>
                            <b className={"App_title"}>{this.state.infoModalTitle}</b>
                        </div>
                    </div>
                    <div className={"modal-body"}>
                        {this.state.infoModalBody}
                    </div>
                    <div className={"modal-footer"}>
                        <button
                            onClick={this.handleSwitchModal}
                            className={"btn App_white_text button"}
                            style={{background: "#ff0003", color: "#FFFFFF"}}
                        >{this.props.t("close")}
                        </button>
                    </div>
                </Modal>
            </>
        );
    }
}

export default withTranslation("translations")(withCookies(ScreenChoice));
